const session = state => state.session

export default {
  session,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/session/getters.js